// extracted by mini-css-extract-plugin
export default {"map":"info-tab_map__oXh9l"};